import { RootStore } from 'core/stores/root-store';
import Cookies from 'js-cookie';
import React, { ReactNode } from 'react';

export const RootStoreContext = React.createContext<RootStore | null>(null);

export const RootStoreProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState<RootStore>(() => new RootStore());
   const userToken = Cookies.get('tokenClient');

   React.useEffect(() => {
      if (userToken) {
         store.userStore.chekUser();
      } else {
         store.userStore.setInit(false);
      }
   }, [store, userToken]);

   return <RootStoreContext.Provider value={store}>{children}</RootStoreContext.Provider>;
};
